/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { MenuItemType } from '@wit/vtv-x-foundation-lib';
import { RailMetaData } from 'ui/pages/myTv/MainPage';

import MyTVWishlist from './MyTVWishlist';
import MyTVRecordings from './MyTVRecordings';
import MyTVPurchasesAndRentals from './MyTVPurchasesAndRentals';
import MyTVSubscription from './MyTVSubscription';
import MyTVContinueWatching from './MyTVContinueWatching';
import MyTVRecommendation from './MyTVRecommendation';

interface Props {
  rail: RailMetaData;
}

export default function MyTVFactory({ rail }: Props) {
  switch (rail.item.type) {
    case MenuItemType.WISHLIST:
      return <MyTVWishlist rail={rail} />;
    case MenuItemType.RECORDINGS:
      return <MyTVRecordings rail={rail} />;
    case MenuItemType.SCHEDULE_RECORDINGS:
      return <MyTVRecordings rail={rail} />;
    case MenuItemType.RENTALS:
      return <MyTVPurchasesAndRentals rail={rail} />;
    case MenuItemType.SUBSCRIPTIONS:
      return <MyTVSubscription rail={rail} />;
    case MenuItemType.CONTINUE_WATCHING:
      return <MyTVContinueWatching rail={rail} />;
    case MenuItemType.EXTERNAL:
      return <MyTVRecommendation rail={rail} />;
    default:
      return null;
  }
}
